import posthog from 'posthog-js'
import { POSTHOG_CONFIG } from './constants'

export function initPostHog(): void {
  if (typeof window === 'undefined') return
  const apiKey = process.env.NEXT_PUBLIC_POSTHOG_API_KEY ?? ''
  if (!apiKey) return
  if ((posthog as { __loaded?: boolean }).__loaded) return
  try {
    posthog.init(apiKey, {
      api_host: POSTHOG_CONFIG.API_HOST,
      capture_pageview: false,
      capture_pageleave: true,
    })
  } catch {
    // blocked by ad-blocker — silent fail
  }
}

export function trackEvent(name: string, properties?: Record<string, unknown>): void {
  try {
    posthog.capture(name, properties)
  } catch {
    // PostHog unavailable — silent fail
  }
}
